module.exports = __webpack_public_path__ + "img/professional.bcba9b41.jpg";